import PropTypes from 'prop-types';
import { useMemo } from 'react';
import getTargetAttribute from '../services/getTargetAttribute';
import scrollToOverlayListItemObserver from '../services/scrollToOverlayListItemObserver';
import SelectField from './SelectField';
import { renderTimezoneOptions } from '../services/renderOptions';

const propTypes = {
    label: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    /**
     * Timezones list holding timezone values and labels
     *
     * @example
     * [{
     *    value: 'America/Los_Angeles',
     *    label: '(GMT-08:00) Pacific Standard Time (America/Los_Angeles)'
     * }]
     */
    timezones: PropTypes.arrayOf(
        PropTypes.exact({
            label: PropTypes.string,
            value: PropTypes.string,
        }),
    ),
    value: PropTypes.string,
};

const TimezoneField = ({ label, onChange, timezones, value }) => {
    const observer = scrollToOverlayListItemObserver(value);
    const options = useMemo(() => renderTimezoneOptions(timezones), [timezones]);

    const handleMenuOpen = (open) => {
        if (open) {
            observer.observe(document.body, { childList: true });
        } else {
            observer.disconnect();
        }
    };

    return (
        <SelectField
            onChange={onChange}
            onMenuOpen={handleMenuOpen}
            label={label}
            value={value}
            data-target={getTargetAttribute('timezone-field')}
        >
            {options}
        </SelectField>
    );
};

TimezoneField.propTypes = propTypes;

export default TimezoneField;
